<script>
export default {
    name: "AccountsFinanceReports",
}
</script>
<template>
  <tail-base-layout>
      <template v-slot:content>
        <div class="flex flex-wrap">
                <div class="w-full text-center bg-blue-500 p-tiny rounded-md mx-2">
                    <h5 class="text-white font-bold text-base">Accounts And Finance Reports</h5>
                </div>
                <div class="w-full md:w-1/3 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.accounts-finance.unposted-bills-report.index`)">
                    <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.unposted-bills-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-3 bg-green-600">
                                        <i class="fas fa-coins fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Unposted bills Reports</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.posted-bills-report.index`)">
                    <div class="bg-orange-100 border-b-4 border-orange-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.posted-bills-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-orange-600">
                                        <i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Posted Bills Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.cancelled-bills-report.index`)">
                    <div class="bg-blue-100 border-b-4 border-blue-500 rounded-lg shadow-lg p-1" >
                        <router-link :to="{ name: `reports.accounts-finance.cancelled-bills-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-gray-600">
                                        <i class="fas fa-window-close fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Cancelled Bills Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.invoices-report.index`)">
                    <div class="bg-purple-100 border-b-4 border-purple-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.invoices-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Invoices Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div> 
              
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.push-received-payments-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.push-received-payments-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-hand-holding fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Push Received Payments</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>  <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.push-deposits-payments-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.push-deposits-payments-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-hand-holding fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Push Deposit Payments</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div> 
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.declared-received-payments-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.declared-received-payments-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-hand-holding fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Declared Received Payments</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.invoices-report.general`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.invoices-report.general` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Invoices Report Summary</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.invoices-per-visit-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.invoices-per-visit-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Invoices Per Visit Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                 <!-- <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.nhif-monthly-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">NHIF Monthly Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div> -->
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.cashout-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.cashout-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-redo fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Cash Out</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.received-payments-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.received-payments-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-hand-holding fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Received Payments</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.weivered-bills-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.weivered-bills-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-power-off fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Weivered Bills</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>                                                           
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.combined-invoice-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ 
                                name: `reports.accounts-finance.combined-invoices-report.index`, 
                            }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-power-off fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Combined Invoice</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.mpesa-pay-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.mpesa-pay-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">M-pesa payments</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div> <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.accounts-finance.mpesa-pay-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.accounts-finance.departmental-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-600">
                                        <i class="fas fa-file-invoice fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Departmental </h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
      </template>
</tail-base-layout>
</template>